import { invalidateSheetCache } from '../hooks/useSheetData.js';

const OUTREACH_REFRESH_KEY = 'salesdash:outreach-refresh';

export function broadcastOutreachRefresh() {
  const payload = String(Date.now());
  try { localStorage.setItem(OUTREACH_REFRESH_KEY, payload); } catch {}
  try { window.dispatchEvent(new CustomEvent('salesdash:outreach-refresh', { detail: { at: payload } })); } catch {}
}

export function createDataRefreshCoordinator({ refresh, refreshOutreach }) {
  const refreshAll = async () => {
    invalidateSheetCache();
    await refresh();
  };

  const refreshAllTwice = async ({ delayMs = 4000 } = {}) => {
    await refreshAll();
    setTimeout(() => {
      invalidateSheetCache();
      refresh().catch(() => {});
    }, delayMs);
  };

  const refreshOutreachOnly = async () => {
    await refreshOutreach();
  };

  return {
    refreshAll,
    refreshAllTwice,
    refreshOutreachOnly,
    broadcastOutreachRefresh,
  };
}
